import { makeAutoObservable } from "mobx";
import { CancelMarketingDTO, DeleteRestingPlaceDTO, DetailMarketingDTO, MarketingDTO, RestingPlaceDTO, RestingPlaceListDTO } from "../models/models";
import agent from "../api/agent";

export default class CompanyNewStore {

    companyNews: MarketingDTO | undefined = undefined;

    loadingInitial = false;
    modalLoadingInitial = false;

    constructor() {
        makeAutoObservable(this);
    }
    setLoadingInitial = (val: boolean) => {
        this.loadingInitial = val;
    }
    setModalLoadingInitial = (val: boolean) => {
        this.modalLoadingInitial = val;
    }

    loadCompanyNews = async () => {
        this.setModalLoadingInitial(true);
        try {
            const result = await agent.CompanyNew.list();
            if (result) {
                this.companyNews = JSON.parse(JSON.stringify(result));
                return true
            }
            else
                return false;
        } catch (error) {
            //console.log(error);
            return false;
        }
        finally {
            this.setModalLoadingInitial(false);
        }
    }

    delete = async (req: DeleteRestingPlaceDTO) => {
        this.setModalLoadingInitial(true);
        try {
            var res = await agent.RestingPlaces.delete(req);
            return res;
        } catch (error) {
            //console.log(error);
            return null;
        }
        finally {
            this.setModalLoadingInitial(false);
        }
    }
    getCompanyNewDetail = async (id: string): Promise<DetailMarketingDTO | null> => {
        this.setModalLoadingInitial(true);
        try {
            const result = await agent.CompanyNew.detail(id);
            return result;
        } catch (error) {
            //console.log(error);
            return null;
        }
        finally {
            this.setModalLoadingInitial(false);
        }
    }
    cancelCompanyNew = async (companyNew: CancelMarketingDTO) => {
        this.setModalLoadingInitial(true);
        try {
            var res = await agent.CompanyNew.cancelCompanyNew(companyNew);
            return res;
        } catch (error) {
            //console.log(error);
            return null;
        }
        finally {
            this.setModalLoadingInitial(false);
        }
    }


    createCompanyNew = async (companyNew: FormData) => {
        try {
            return await agent.CompanyNew.createCompanyNew(companyNew);
        } catch (error) {
            //console.log(error);
            return false;
        }
    }

    updateRestingPlace = async (restingPlace: FormData) => {
        try {
            return await agent.RestingPlaces.update(restingPlace);
        } catch (error) {
            //console.log(error);
            return false;
        }

    }
}